import { UserButton } from "@clerk/nextjs"
import { ChartArea } from "lucide-react"

const DotIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z" />
        </svg>
    )
}
const CustomUserButton = ({username}: {username?: string}) => {
    return (
        <header>
            <UserButton
                appearance={{
                    elements: {
                        userButtonAvatarBox: "w-30 h-30 mt-1 border border-amber-500/50"
                    }
                }}>
                <UserButton.MenuItems>
                    <UserButton.Link
                        label="Visit profile"
                        labelIcon={<ChartArea width={16} />}
                        href={`/profile/${username}`}
                    />
                </UserButton.MenuItems>
            </UserButton>
        </header>
    )
}
export default CustomUserButton